import type { Feature } from '@luna/gatekeeper';

export const temporaryLimits: Feature = {
    enabled: false,
    _description:
        'Enables temporary limits feature display on the card features page and supplementary card settings page',
};
